import React from "react";
import './main-footer.css';
import { Link } from 'react-router-dom'; 

const MainFooter = ( {...props} ) => {
    const { hidden } = props;
    return hidden ? <div id="main-footer" /> : <div className="main-footer" id="main-footer">
        <div className="main-footer-inner">
            <div className="main-footer-top">
                <Link to="https://modul.rr-tour.ru" target="_blank" className="footer-brand">РУСРЕГИОНТУР</Link>
                <div className="footer-links">
                    <Link to={`/article/${encodeURIComponent("https://kb.rr-tour.ru/article/2170")}`} target="_blank" className="footer-ref">Пользовательское соглашение</Link>
                    <Link to={`/article/${encodeURIComponent("https://kb.rr-tour.ru/article/2169")}`} target="_blank" className="footer-ref">Условия и правила</Link>
                    <Link to={`/article/${encodeURIComponent("https://kb.rr-tour.ru/article/2171")}`} target="_blank" className="footer-ref">Описание сервиса</Link>
                </div>
            </div>
            <div className="main-footer-bottom">
                <span>© 2012–2026 РУСРЕГИОНТУР. Все права защищены.</span>
            </div>
        </div>
    </div>
}

export default MainFooter;
